export default __webpack_public_path__ + "static/media/mobile-tour-templates-img.d1f371d6.svg";